import {ShowRecaptchaPopup} from "./Recaptcha";
import {errorAlert} from "./jquery-confirm";

export const ErrorHandler = function (xhr, form = null, options = {}) {

    if (form) {
        form.find('.alert').remove();
        form.find('.input-feedback').remove();
    }

    if (ShowRecaptchaPopup(xhr)) {
        return;
    }

    let defaultMessage = 'حدث خطأ غير متوقع أثناء تنفيذ العملية. يرجى إعادة تحميل الصفحة والمحاولة مجددا!';
    if (typeof window.application.ods !== 'undefined' && typeof window.application.ods.js_trans !== 'undefined' && typeof window.application.ods.js_trans.something_went_wrong !== 'undefined') {
        defaultMessage = window.application.ods.js_trans.something_went_wrong;
    }

    let message = defaultMessage;

    if (typeof xhr.responseJSON !== 'undefined') {
        if (typeof xhr.responseJSON.message !== 'undefined') {
            message = xhr.responseJSON.message;
        }

        if (form) {
            if (form.find('[name="recaptcha"]').length && typeof window.grecaptcha !== 'undefined') {
                window.grecaptcha.reset();
            }
            if (typeof xhr.responseJSON.errors !== 'undefined') {
                $.each(xhr.responseJSON.errors.form_fields, function (fieldCode, errData) {
                    let input = form.find(`[name="${fieldCode}"]`);

                    if (!input.length) {
                        input = form.find(`[data-name="${fieldCode}"]`);
                    }
                    if (input.length) {
                        let group = input.closest('.attachments-item__wrapper').first();
                        if (!group.length) {
                            group = input.closest('.form-group2,.ods-form-group').first();
                        }

                        group.addClass('has-error').addClass('ods-form-group--has-error').append(`<div class="is-error input-feedback input-feedback__error ods-form-group__feedback"><div class="ods-form-group__feedback__msg">${errData.message}</div></div>`);
                    } else {
                        form.prepend(`<div class="is-error alert alert-error alert-danger">${errData.message}</div>`);
                    }
                });
            } else if (typeof xhr.responseJSON.message !== 'undefined') {
                ///form.prepend(`<div class="is-error alert alert-error alert-danger">${message}</div>`);
                errorAlert(message)
            }
            const firstErr = form.find('.is-error').first();
            if (firstErr.length) {
                $('html, body').stop().animate({
                    scrollTop: firstErr.offset().top - 20
                }, 1000);

            }

            return;
        }
    }
    if (form) {
        form.prepend(`<div class="is-error alert alert-error alert-danger mb20">${message}</div>`);
        form.addClass('has-error');
        return;
    }
    let alertOptions = options.alert_options || {};

    return errorAlert(message, alertOptions)

};
